import React from 'react';
import PositionRiskWidgetBuilder from './PositionRiskWidgetBuilder';
import PositionRiskWidgetRenderer from './PositionRiskWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { PositionRiskWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';

export { default as PositionRiskWidgetBuilder } from './PositionRiskWidgetBuilder';
export { default as PositionRiskWidgetRenderer } from './PositionRiskWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'position_risk',
  meta: {
    label: 'Position Risk',
    icon: React.createElement(FontAwesomeIcon, { icon: faChartBar }),
    description: 'Position sizing, risk exposures, and liquidity metrics',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  defaultSize: { w: 4, h: 5, minW: 3, minH: 3 },
  defaultConfig: () => ({} as PositionRiskWidgetConfig),
  Builder: PositionRiskWidgetBuilder,
  Renderer: PositionRiskWidgetRenderer,
  Preview,
};
